import { FC, useMemo } from 'react';
import { GaugeChart, LayoutCarousel } from '@silverfort/sf-components';
import { GaugeChartCarouselProps } from '../../types/GaugeChartProps';

type AccessIntelligenceGaugeCarouselWidgetProps = {
    chartLabel: string;
    charts: Array<GaugeChartCarouselProps>;
    loading: boolean;
    widgetTitle: string;
};

export const AccessIntelligenceGaugeCarouselWidget: FC<AccessIntelligenceGaugeCarouselWidgetProps> = ({
    chartLabel,
    charts,
    loading,
    widgetTitle
}) => {
    const pages = useMemo(() => {
        return charts.map((item, index) => (
            <GaugeChart
                chartSize={200}
                endColor={item.endColor}
                key={`${chartLabel}-${index}`}
                isLoading={loading}
                label={chartLabel}
                startColor={item.startColor}
                value={item.value}
            />
        ));
    }, [chartLabel, charts, loading]);

    return (
        <LayoutCarousel contentClassName="flex flex-1 flex-col justify-center px-6" pages={pages} title={widgetTitle} />
    );
};
